import Bugsnag from "@bugsnag/js";
import type { NotifiableError } from "@bugsnag/js";
import {
  BUGSNAG_API_KEY,
  BUGSNAG_ENABLED_RELEASE_STAGES,
} from "@circle-react/config/Settings";

interface AppMetadata {
  electronRunningOn?: string;
  electronVersion?: string;
  platform: "desktop" | "web" | "branded_app";
}

// TODO: add 'mobile' platform
// TODO: add more metadata related to specific platforms
const buildAppMetadata = (): AppMetadata => {
  const appMetadata: AppMetadata = {
    platform: "web",
  };

  const isBrandedApp = !!window?.webview?.isComingFromReactNativeWebview;
  if (isBrandedApp) {
    appMetadata.platform = "branded_app";
  }

  const isDesktopApp = !!window.electronAPI;
  if (isDesktopApp) {
    appMetadata.platform = "desktop";
    appMetadata.electronVersion = window.electronAPI?.version;
    appMetadata.electronRunningOn = window.electronAPI?.runningOn;
  }

  return appMetadata;
};

// https://docs.bugsnag.com/platforms/javascript/configuration-options/#autodetecterrors
export const initializeBugsnag = () => {
  const isDesktopApp = !!window.electronAPI;

  const config: any = {
    apiKey: BUGSNAG_API_KEY,
    releaseStage: window.RAILS_ENV,
    enabledReleaseStages: BUGSNAG_ENABLED_RELEASE_STAGES,
    autoDetectErrors: false, // Disable auto detection, hence prevent bugsnag getting spammed.
  };

  // TODO: replace with `buildAppMetadata` if it works as expected
  if (isDesktopApp) {
    config.metadata = {
      app: {
        platform: "desktop",
        electronVersion: window.electronAPI?.version,
        runningOn: window.electronAPI?.runningOn,
      },
    };
  }

  Bugsnag.start(config);
};

export interface BugsnagMetadata {
  [key: string]: Record<string, unknown>;
}

export const notifyBugsnag = (
  error: NotifiableError,
  metadata?: BugsnagMetadata,
) => {
  Bugsnag.notify(error, event => {
    event.addMetadata("app", buildAppMetadata());
    if (metadata) {
      Object.entries(metadata).forEach(([section, data]) => {
        event.addMetadata(section, data);
      });
    }
  });
};

export const addBugsnagBreadcrumb = (breadcrumb: string) => {
  Bugsnag.leaveBreadcrumb(breadcrumb);
};
